import React, { useEffect, useRef, useState } from 'react'
import NavBar from '../../components/navBar/NavBar'
import { auth, db, storage } from '../../utitilties/firebase'
import './addPhysio.css'
import { collection, addDoc, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import {
    ref,
    uploadBytesResumable,
    getDownloadURL
} from "firebase/storage";
import { useLocation, useNavigate } from 'react-router-dom';
import BackIco from '../../assets/icons/back.png'
const AddPhysio = () => {

    const navigate = useNavigate()

    const { state } = useLocation()
    const logoInputRef = useRef()

    const isSuperAdmin = auth.currentUser.email == 'admin@orebro.com'

    const [name, setName] = useState('')
    const [logo, setLogo] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [phNo, setPhNo] = useState('')
    const [address, setAddress] = useState('')
    const [location, setLocation] = useState('')
    const [center, setCenter] = useState('')

    const addHandler = async () => {

        if ([name, email].includes('')) {
            return alert('Fill Name to continue.')
        }

        if (!String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) {
            return alert('Enter a valid email')
        }
        let isEmailExist = await checkIfemailExist()
        if (isEmailExist) {
            return alert('Email already Exists')
        }

        const storageRef = ref(storage, `/Logos/${name + email}`)
        const uploadTask = uploadBytesResumable(storageRef, logo);


        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const percent = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                // console.log(percent)
                // update progress
                // setPercent(percent);
            },
            (err) => console.log(err),
            () => {
                // download url
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    addToDb(url)
                });
            }
        );


    }

    const addToDb = async (logoUrl,) => {  // function to add to db as new

        let center = await getUser()

        let latestInvCode = await getLatestInvitationCode(center)




        const docRef = await addDoc(collection(db, isSuperAdmin ? "PhysioCenters" : "PhysioTherapists"), {
            name,
            email,
            ...(phNo && { phNo }),
            ...(address && { address }),
            ...(logo && { logo: logoUrl }),
            ...(location && { location }),
            ...(isSuperAdmin && { centerCode: Number(String(latestInvCode).substring(0, 2)) + 1 }),
            ...(!isSuperAdmin && { invitationCode: latestInvCode + 1 }),
            ...(!isSuperAdmin && { centerId: center.id }),
            isAuthSet: false,
        }).then(() => {
            alert('Submitted')
            navigate('/')
        }).catch((error) => alert('Error'))
    }

    const updateDb = async (url) => {


        const docRef = await updateDoc(doc(db, isSuperAdmin ? "PhysioCenters" : "PhysioTherapists", state?.center?.id), {
            name,
            email,
            ...(phNo && { phNo }),
            ...(address && { address }),
            ...(logo && { logo: url }),
            ...(location && { location }),
        }).then(() => {
            alert('Updated')
            navigate('/')
        }).catch((error) => alert('Error'))
    }

    const updateUser = async () => {
        if ([name, email, logo, phNo].includes('')) {
            return alert('Fill all fields and select a logo')
        }

        if (!String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) {
            return alert('Enter a valid email')
        }
        
        if (validURL(logo)) {
            updateDb(logo)
        }
        else if (logo) {
            const storageRef = ref(storage, `/Logos/${name + email}`)
            const uploadTask = uploadBytesResumable(storageRef, logo);


            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const percent = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );

                },
                (err) => console.log(err),
                () => {
                    // download url
                    getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                        updateDb(url)
                    });
                }
            )
        }
    }


    const checkIfemailExist = async () => {

        const q = query(collection(db, "PhysioCenters"), where("email", "==", email));

        const querySnapshot = await getDocs(q);

        if (querySnapshot.size == 0) {
            return false
        } else {
            return true
        }

    }
    const getUser = async () => {

        const q = query(collection(db, "PhysioCenters"), where("email", "==", auth.currentUser.email));

        const querySnapshot = await getDocs(q);
        let tempUser = ''
        querySnapshot.forEach((doc) => {
            tempUser = { id: doc.id, ...doc.data(), }
        })

        setCenter(tempUser)
        return tempUser



    }

    const getLatestInvitationCode = async (cent) => {



        let latestCode = 0

        if (isSuperAdmin) {
            latestCode = 10
            const q = query(collection(db, "PhysioCenters"));

            const querySnapshot = await getDocs(q);


            querySnapshot.forEach(doc => {
                if (doc.data().centerCode > latestCode) {
                    latestCode = doc.data().centerCode
                }



            })


        } else {
            const q = query(collection(db, "PhysioTherapists"));

            const querySnapshot = await getDocs(q);


            querySnapshot.forEach(doc => {
                if (doc.data().centerId == cent.id) {
                    if (doc.data().invitationCode > latestCode) {
                        latestCode = doc.data().invitationCode
                    }
                }



            })

            if (!latestCode) {  //this will be true if no therapists for this user


                latestCode = Number(String(cent.centerCode) + '00')
            }
        }




        return Number(latestCode)

    }

    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }


    useEffect(() => {
        if (state?.edit) {
            setName(state.center.name)
            setLogo(state.center.logo)
            setEmail(state.center.email)
            setPhNo(state.center.phNo)
            setAddress(state.center.address)
            setLocation(state.center.location)
        }
    }, [])

    return (
        <>
            <NavBar />
            <div className='add_contaner' >
                <div className='add_sub' >
                    <div className='header' >
                        <img src={BackIco}
                            className="back_ico"
                            onClick={() => navigate(-1)}
                        />
                        <h1 className="title">Add {isSuperAdmin?'Physio Center':'PhysioTherapist'}</h1>
                    </div>
                    <input type="text" className="text_input" placeholder='Name' value={name} onChange={(e) => setName(e.target.value)} />
                    <input type="text" className="text_input" placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} disabled={state?.edit} />
                    <input type="text" className="text_input" placeholder='Phone Number' value={phNo} onChange={(e) => setPhNo(e.target.value)} />
                    {isSuperAdmin &&
                        <>
                            <input type="text" className="text_input" placeholder='Location Link' value={location} onChange={(e) => setLocation(e.target.value)} />
                            <textarea className="text_input" placeholder='Address' rows={6} value={address} onChange={(e) => setAddress(e.target.value)} >

                            </textarea>


                            {logo && <img src={logo ? validURL(logo) ? logo : URL.createObjectURL(logo) : ""} className='logo' />}

                            <input type='file' hidden ref={logoInputRef} onChange={(e) => setLogo(e.target.files[0])} />
                            <div className='btn logo_btn' onClick={() => logoInputRef.current.click()} >
                                Select Logo
                            </div>
                        </>
                    }
                    <div className='btn'
                        onClick={() => { state?.edit ? updateUser() : addHandler() }}
                    >
                        {state?.edit ? 'Update' : 'Submit'}
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPhysio